import { render, staticRenderFns } from "./BlinkingDots.vue?vue&type=template&id=0f17c4ba&scoped=true&"
import script from "./BlinkingDots.vue?vue&type=script&lang=js&"
export * from "./BlinkingDots.vue?vue&type=script&lang=js&"
import style0 from "./BlinkingDots.vue?vue&type=style&index=0&id=0f17c4ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f17c4ba",
  null
  
)

export default component.exports